<template>
    <div class="card col-md-8 mx-auto px-0">
        <div class="card-body">
            <div class="form-group">
                <label class="font-weight-bold required"
                       :for="'oldPassword' + _uid">{{ $t('changePassword.oldPassword') }}</label>
                <input type="password" class="form-control"
                       v-model="changePassword.oldPassword"
                       v-validate="'required'"
                       :data-vv-as="$t('changePassword.oldPassword')"
                       :name="'oldPassword' + _uid"
                       :id="'oldPassword' + _uid"
                       :readonly="allowAnonymous || !allowInput || editing">
                <div class="text-danger" v-if="errors.has('oldPassword' + _uid)">
                    {{ errors.first('oldPassword' + _uid) }}
                </div>
            </div>

            <div class="form-group">
                <label class="font-weight-bold required" :for="'newPassword' + _uid">
                    {{ $t('changePassword.newPassword') }}</label>
                <input type="password" class="form-control"
                       ref="passwordRef"
                       v-model="changePassword.newPassword"
                       v-validate="'required|upCaseNum'"
                       :data-vv-as="$t('changePassword.newPassword')"
                       :name="'newPassword' + _uid"
                       :id="'newPassword' + _uid"
                       :readonly="allowAnonymous || !allowInput || editing">
                <div class="text-danger" v-if="errors.has('newPassword' + _uid)">
                    {{ errors.first('newPassword' + _uid) }}
                </div>
            </div>

            <div class="form-group">
                <label class="font-weight-bold required" :for="'newPasswordConfirm' + _uid">
                    {{ $t('changePassword.newPasswordConfirm') }}
                </label>
                <input type="password" class="form-control"
                       v-model="changePassword.newPasswordConfirm"
                       v-validate="`required|confirmPass:${changePassword.newPassword}`"
                       :data-vv-as="$t('changePassword.newPasswordConfirm')"
                       :name="'newPasswordConfirm' + _uid"
                       :id="'newPasswordConfirm' + _uid"
                       :readonly="allowAnonymous || !allowInput || editing"
                       @keyup.enter="editPassword">
                <div class="text-danger" v-if="errors.has('newPasswordConfirm' + _uid)">
                    {{ errors.first('newPasswordConfirm' + _uid) }}
                </div>
            </div>

            <div class="form-group" v-if="editable">
                <div class="btn-group">
                    <button type="button" class="btn btn-primary btn"
                            :class="saving ? 'disabled' : ''" @click.stop="editPassword">
                        <i class="fas fa-spinner fa-spin" v-if="saving"></i>
                        <i class="fas fa-save" v-else></i>
                        {{ $t('buttons.save.btnText') }}
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { ChangePassword } from '@/models/models';

export default {
    inject: ['$validator'],
    props: {
        title: String,
        editable: {
            default: true,
            type: Boolean
        },
        allowAnonymous: {
            type: Boolean,
            default: false
        },
        allowInput: {
            type: Boolean,
            default: true
        },
    },
    components: {},
    data() {
        return {
            saving: false,
            editing: false,
            changePassword: new ChangePassword()
        }
    },
    created() {
        if (!this.changePassword) {
            this.changePassword = new ChangePassword();
        }
    },
    mounted() {
    },
    methods: {
        editPassword() {
            this.$validator.validateAll().then(result => {
                if (result) {
                    this.saving = true;

                    this.$http.put('/api/Account/ChangePassword', this.changePassword).then((response => {
                        this.$vs.notify({
                            title: this.$t('person.changePassword'),
                            text: this.$t('forgottenPasswordIsReset'),
                            color: 'success',
                            time: this.$store.getters.notificationDuration
                        });

                        this.saving = false;
                        this.clearData();
                    })).catch(error => {
                        this.$vs.notify({
                            title: this.$t('person.changePassword'),
                            text: this.$helpers.errorText(error),
                            color: 'danger',
                            time: this.$store.getters.notificationDuration
                        });

                        this.saving = false;
                    });
                }
            });
        },
        clearData() {
            this.editing = false;
            this.changePassword = new ChangePassword();
            this.$validator.reset();
        },
    }
}
</script>

<style scoped>
</style>
